<template>
    <div>
        <template>
            <tabs fill class="flex-column flex-md-row">
                <card shadow>                                    

                    <tab-pane 
                        title="Pending Applications"
                        @tab-activated="triggerPendingApplications" 
                    >
                        <span slot="title">
                            <i class="ni ni-books"></i>
                            Pending Applications
                        </span>
                        <!-- import Pending Applications template here -->
                        <PendingApplications
                            :privileges="privileges"
                            :changeTitle="changeTitle"
                            :loadTitle="loadTitle"
                            :id="id"
                            :type="type"
                            :status="'submitted'"
                            ref="callPendingApplications"
                        />
                    </tab-pane>

                    <tab-pane 
                        title="Rejected Applications"
                        @tab-activated="triggerRejectedApplications" 
                    >
                        <span slot="title">
                            <i class="ni ni-badge"></i>
                            Rejected Applications
                        </span>
                        <!-- import Rejected Applications template here -->
                        <PendingApplications
                            :privileges="privileges"
                            :changeTitle="changeTitle"
                            :loadTitle="loadTitle"
                            :id="id"
                            :type="type"
                            :status="'rejected'"
                            ref="callRejectedApplications"
                        />
                    </tab-pane>

                    <tab-pane 
                        title="Approved Applications"
                        @tab-activated="triggerApprovedApplications" 
                    >
                        <span slot="title">
                            <i class="ni ni-archive-2"></i>
                            Approved Applications
                        </span>
                        <PendingApplications
                            :privileges="privileges"
                            :changeTitle="changeTitle"
                            :loadTitle="loadTitle"
                            :id="id"
                            :type="type"
                            :status="'approved'"
                            ref="callApprovedApplications"
                        />
                    </tab-pane>

                </card>
            </tabs>
        </template>
    </div>
</template>
<script>
    import PendingApplications from './PendingApplications/PendingApplications';

    export default {
        name: 'MedicalApplications',
        props: ['privileges', 'changeTitle', 'loadTitle', 'id', 'type'],
        components: {
            PendingApplications
        },
        methods: {
            triggerPendingApplications() {
                if (this.$refs.callPendingApplications && this.$refs.callPendingApplications.loadAplications) {
                    this.$refs.callPendingApplications.loadAplications();
                }
            },
            triggerRejectedApplications() {
                if (this.$refs.callRejectedApplications && this.$refs.callRejectedApplications.loadAplications) {
                    this.$refs.callRejectedApplications.loadAplications();
                }
            },
            triggerApprovedApplications() {
                if (this.$refs.callApprovedApplications && this.$refs.callApprovedApplications.loadAplications) {
                    this.$refs.callApprovedApplications.loadAplications();
                }
            }
        }
    };
</script>
<style></style>
